import { fetcher } from "helpers/fetcher";

import { TGetBUUnassignedMemberReq, TGetBUUnassignedMemberRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getBUUnassignedMember = async (
  params?: TGetBUUnassignedMemberReq
) => {
  return await fetcher<TGetBUUnassignedMemberRes, TGetBUUnassignedMemberReq>(
    ENDPOINT.BU.GET_BU_UNASSIGNED_MEMBER,
    {
      params: params?.data,
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.BU.GET_BU_UNASSIGNED_MEMBER.version,
        [API_HEADER.BU_ID]: params?.idBu,
      },
    }
  );
};

export const queryGetBUUnassignedMember = async (
  params?: TGetBUUnassignedMemberReq
) => {
  return (await getBUUnassignedMember(params)).data;
};

queryGetBUUnassignedMember._key = (params?: TGetBUUnassignedMemberReq) => [
  ENDPOINT.BU.GET_BU_UNASSIGNED_MEMBER.url,
  params,
];
